var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    vectorEffect: "non-scaling-stroke",
    stroke: "var(--icon-color, #001e00)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.364,
    d: "M7.63 17.2v2.9a.88.88 0 00.9.9h6.81a.88.88 0 00.9-.9v-1.29h2.19a.88.88 0 00.9-.9v-3.34h1.16c.51 0 .64-.38.38-.77l-1.67-3v-1a6.6 6.6 0 00-3.68-6.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    vectorEffect: "non-scaling-stroke",
    stroke: "var(--icon-color, #001e00)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.5 10.22A1.5 1.5 0 107 8.72a1.5 1.5 0 001.5 1.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    vectorEffect: "non-scaling-stroke",
    stroke: "var(--icon-color, #001e00)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.49 9.12v-.79L14 7.05a5.75 5.75 0 00-1.39-2.34l-1.85.7a4.48 4.48 0 00-.56-.32h0l-.33-1.92a5.53 5.53 0 00-2.74 0L6.8 5.09a4.48 4.48 0 00-.56.32l-1.85-.7A5.75 5.75 0 003 7.05l1.51 1.28a3.39 3.39 0 000 .78L3 10.38a5.79 5.79 0 001.39 2.35L6.24 12a6.22 6.22 0 00.56.32l.33 1.91a5.53 5.53 0 002.74 0l.33-1.91a6.22 6.22 0 00.56-.32l1.85.7A5.79 5.79 0 0014 10.38l-1.51-1.27z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.8c8887161cd86f8919ee892b5f98b420.svg";
export { ForwardRef as ReactComponent };